import { styled } from '@mui/material';

export const StyledCircle = styled('div')((props: { color: string; size: string }) => `
  background-color: ${props.color};
  width: ${props.size};
  height: ${props.size};
  border-radius: ${props.size};
`);
